import * as React from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

import { PersonModal } from '../../constants';

interface IOwnProps {}

interface IStateProps {}

interface IDispatchProps {
    updateQueryString: Function;
}

export interface IProps extends IOwnProps, IStateProps, IDispatchProps {}

export class PersonCreateButton extends React.PureComponent<IProps> {
    handleClick = () => {
        this.props.updateQueryString({
            [PersonModal.PERSON_CREATE_MODAL]: true
        });
    };

    render() {
        return (
            <Button circular secondary size="small" onClick={this.handleClick}>
                Create Person
            </Button>
        );
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(null, {
    updateQueryString
})(PersonCreateButton);
